var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BSGLink',_vm._g({staticClass:"bsg-card-selectable block",class:{
    selected: _vm.selected,
    disabled: _vm.disabled,
    clickable: Object.keys(_vm.$listeners).length || _vm.to,
  },attrs:{"to":_vm.to,"title":_vm.title,"functional":""}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }